import { Button } from "@/components/ui/button";
import { createRule } from "@/queries/playlists";
import { useState } from "react";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { useToast } from "@/components/ui/use-toast";
import { useQueryClient } from "@tanstack/react-query";
import { Plus } from "lucide-react";
import { RuleForm } from "./RuleForm";

export function CreateRuleButton() {
  const [isOpen, setIsOpen] = useState(false);
  const { toast } = useToast();
  const queryClient = useQueryClient();
  const createMutation = createRule();

  const handleSuccess = () => {
    queryClient.invalidateQueries({ queryKey: ["rules"] });
    toast({
      title: "Success",
      description: "Rule created successfully",
    });
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button size="sm" variant="secondary" className="h-8 border-dashed">
          <Plus className="h-4 w-4 mr-2" />
          Add Rule
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Create New Rule</DialogTitle>
          <DialogDescription>
            Create a new rule to automate actions based on location conditions.
          </DialogDescription>
        </DialogHeader>
        <RuleForm
          mode="create"
          onSuccess={handleSuccess}
          mutation={createMutation}
        />
      </DialogContent>
    </Dialog>
  );
}
